import React from "react"

import BaseStoreButtons from "../../../../../StoreButtons"
import FooterAppStore from "./AppStore"

const StoreButtons = () => {
  return (
    <BaseStoreButtons>
      <FooterAppStore />
    </BaseStoreButtons>
  )
}

export default StoreButtons
